// Hilfsfunktionen für die Namensanzeige

/**
 * Gibt den besten verfügbaren Namen für ein Discord-Mitglied zurück
 * Priorität: Nickname → Global Name → Username → Fallback
 * @param {Object} member - Discord-Mitglied-Objekt
 * @returns {string} Der beste verfügbare Name
 */
export const getDisplayName = (member) => {
    return member.nick || 
           member.global_name || 
           member.username || 
           'Unbekanntes Mitglied';
};


/**
 * Gibt den besten verfügbaren Namen für den eingeloggten Benutzer zurück
 * Priorität: Global Name → Username → Fallback
 * @param {Object} userData - Benutzer-Daten-Objekt
 * @returns {string} Der beste verfügbare Name
 */
export const getUserDisplayName = (userData) => {
    if (!userData) return 'Unbekannter Benutzer';
    
    return userData.global_name || 
           userData.username || 
           'Unbekannter Benutzer';
};


/**
 * Gibt den Discord Tag (Username#Discriminator) zurück
 * @param {Object} userData - Benutzer-Daten-Objekt
 * @returns {string} Discord Tag
 */
export const getDiscordTag = (userData) => {
    if (!userData) return 'Unbekannter Tag';
    
    if (userData.username && userData.discriminator) {
        return `${userData.username}#${userData.discriminator}`;
    }
    return userData.username || 'Unbekannter Tag';
};
